import React, { useEffect, useState } from 'react';
import { zeroPad } from 'react-countdown';
import { connect } from 'react-redux';
import axios from 'axios';
import { bindActionCreators } from 'redux';

import BaseSelection from './BaseSelection';
import HeroMakerFooter from './HeroMakerFooter';
import { rangeArray } from '../../utils/helper';
import { removeHeroMakerColoredImage, setTypeAssets } from '../../redux/actions';

import conf from '../../conf';

const BodySelection = (props) => {
  const {
    character,
    body,
    nextTab,
    backTab,
    setBody,
    footerValue,
    heroMaker,
    serviceURL,
    setTypeAssets,
  } = props;
  const [index, setIndex] = useState(body ? body : 0);

  useEffect(() => {
    if (!heroMaker.bodyColor) {
      const tmpAssets = rangeArray(0, 4)
      .map(asset => `${conf.cdn_url}/heromaker/${character}/00_base/15_bodys/preview/${zeroPad(asset)}.png`);
      setTypeAssets('body', tmpAssets);
    } else {
      setTypeAssets('body', null);
      fetchBodies();
    }
  }, [heroMaker.bodyColor, character]);

  useEffect(() => {
    props.removeHeroMakerColoredImage('15_bodys', 1);
  }, [index]);

  const fetchBodies = async () => {
    await axios.post(`${serviceURL}/get-heroMaker-b64-assets`, {
      character,
      bodyColor: heroMaker.bodyColor,
    })
    .then((response) => {
      setTypeAssets('body', response.data);
    })
    .catch((error) => {
      console.log(error);
    });
  };

  const saveAndNextTab = () => {
    setBody(index);
    nextTab();
  };

  return (
    <>
      <div>
        <BaseSelection index={index} assets={heroMaker.bodyAssets} setIndex={setIndex} isBody />
      </div>
      <HeroMakerFooter
        onClick={saveAndNextTab}
        value={footerValue}
        backTab={backTab}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  const { heroMaker } = state;
  return { heroMaker };
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    setTypeAssets,
    removeHeroMakerColoredImage,
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(BodySelection);